import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { PsAcuerdoBasicoService } from '../../../services/ps-acuerdo-basico.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PSAcuerdoBasicoModel } from '../../../models/ps-acuerdo-basico-model';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-ps-acuerdos-basicos-edit',
  templateUrl: './ps-acuerdos-basicos-edit.component.html',
  styleUrls: ['./ps-acuerdos-basicos-edit.component.scss']
})
export class PsAcuerdosBasicosEditComponent implements OnInit {

  acuerdosForm: FormGroup;
  // idPs = -1; // Asigna el IDPS correspondiente
  @Input() idPs: number = 0;

  constructor(
    private fb: FormBuilder,
    private _psAcuerdoBasicoService: PsAcuerdoBasicoService,
    @Optional() public dialogRef: MatDialogRef<PsAcuerdosBasicosEditComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _toastr: ToastrService,
    private _avRoute: ActivatedRoute
  ) {
    this.acuerdosForm = this.fb.group({
      acuerdos: this.fb.array([])
    });

    // if (this._avRoute.snapshot.params['id']) {
    //   this.idPs = this._avRoute.snapshot.params['id'];
    // }

    // console.log(data)
    // if (data !== undefined && data !== null) {
    //   this.idPs = data.idPs
    // }
  }

  ngOnInit(): void {
    this._psAcuerdoBasicoService.getAllById(this.idPs).subscribe(data => {
      this.setAcuerdos(data);
    });
  }

  get acuerdos() {
    return this.acuerdosForm.get('acuerdos') as FormArray;
  }

  setAcuerdos(acuerdos: any): void {
    const formArray = this.acuerdosForm.get('acuerdos') as FormArray;
    acuerdos.forEach(acuerdo => {
      formArray.push(this.fb.group({
        id: [acuerdo.id],
        idPS: this.idPs,
        tipo: [acuerdo.tipo],
        tipoLabel: [acuerdo.tipoLabel],
        descripcion: [acuerdo.descripcion]
      }));
    });
  }

  save(idPs: number): void {
    this.idPs = idPs;

    var acuerdos  = this.acuerdosForm.value.acuerdos.filter(
      (acuerdo: PSAcuerdoBasicoModel) => acuerdo.descripcion && acuerdo.descripcion.trim() !== '');

      if(acuerdos.length > 0) {
        acuerdos.forEach(element => {
          element.idPS = idPs;
        });
        this._psAcuerdoBasicoService.post(acuerdos).subscribe(response => {
          console.log('Guardado con éxito:', response);
          // this.closeDialog();
          this._toastr.success('Guardado')
        }, error => {
          console.error('Error al guardar:', error);
          // this.mensaje = 'Error al guardar los cambios';
        });
      }
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
